import React, { ComponentType } from 'react';
import { CareerId } from '@common/const/catalog/career';
import { ClientType } from '@common/model/client/clientType';
import { AppModalAction, ModalLayout } from '@cp/ds/src/components/modalLayout';
import { IModalProps } from '@cp/shared/modal';
import { cx } from '@emotion/css';
import { createEventFactory } from '@cp/shared/tracking';
import { CLIENT_TYPE_TO_CLIENT_TYPE_NAME, EButtonName, useTrackMount, useTracking } from 'src/shared/tracking';

const OpenClientTypeModal = createEventFactory({
  name: 'client-type-modal-open',
});

const ClientTypeSelected = createEventFactory<{ clientType: ClientType }>({
  name: 'client-type-select',
});

export interface ClientTypeModalProps extends IModalProps<ClientType> {
  careerId?: CareerId;
  CareerIcon?: ComponentType;
}

export const ClientTypeModal: React.FC<ClientTypeModalProps> = ({ onCancel, onSuccess, CareerIcon = () => null }) => {
  const sendClientTypeMetric = useTracking(ClientTypeSelected);
  useTrackMount(OpenClientTypeModal);

  const actions = React.useMemo<AppModalAction[]>(() => {
    const createCallback = (clientType: ClientType) => () => {
      sendClientTypeMetric({ clientType });
      onSuccess(clientType);
    };

    return [
      {
        title: 'Помощника',
        variant: 'primary',
        color: 'gray',
        buttonProps: {
          sx: { width: { xs: 1, lg: 0.5 } },
          className: cx(EButtonName.SelectClientType, CLIENT_TYPE_TO_CLIENT_TYPE_NAME[ClientType.Employer]),
        },
        callback: createCallback(ClientType.Employer),
      },
      {
        title: 'Работу',
        variant: 'primary',
        color: 'pink',
        buttonProps: {
          sx: { width: { xs: 1, lg: 0.5 } },
          className: cx(EButtonName.SelectClientType, CLIENT_TYPE_TO_CLIENT_TYPE_NAME[ClientType.Specialist]),
        },
        callback: createCallback(ClientType.Specialist),
      },
    ];
  }, [onSuccess, sendClientTypeMetric]);

  return <ModalLayout actions={actions} icon={<CareerIcon />} onClose={onCancel} title="Я ищу" />;
};
